import { lazyNamed } from 'src/utils/lazyNamed.ts';
import { SupportAdminTab } from './types.ts';

export { SupportAdminTab };

// The admin surface for the ZZupport assistant: a tab per thing it is administered
// through — the conversations it held, the base it answers from, and what it could not
// answer — and the one case an admin opens out of the chats tab.
const SupportAdmin = {
  Layout: lazyNamed(() => import('./Layout.tsx'), 'Layout'),
  ChatList: lazyNamed(() => import('./ChatList/index.tsx'), 'ChatList'),
  ChatOverview: lazyNamed(() => import('./ChatOverview/index.tsx'), 'ChatOverview'),
  KnowledgeBase: lazyNamed(() => import('./KnowledgeBase/index.tsx'), 'KnowledgeBase'),
  Gaps: lazyNamed(() => import('./Gaps/index.tsx'), 'Gaps'),
};

export default SupportAdmin;
